/* eslint-disable react/prop-types */
import React, { useMemo, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Spin,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import Direccion, { permissionConfig } from 'components/Direccion/index';
import { EnvironmentOutlined, RightOutlined } from '@ant-design/icons';
import { getModelPermission } from 'utils/permission';
import address from 'utils/address';

const ModalDireccion = ({
  visible: _visible,
  baseURI,
  parentID,
  addressPropName,
  callback,
  onCancel,
  required,
  submitControlsWithSentWS,
}) => {
  const permission = useMemo(
    () => getModelPermission(permissionConfig.model, permissionConfig.catalogs),
    [],
  );
  const formInstance = onCancel ? null : Form.useFormInstance();
  const [formAddress, setFormAddress] = useState();
  const [loading, setLoading] = useState();
  const [visible, setVisible] = useState(false);
  const direccionStr = formInstance ? Form.useWatch('direccionStr', formInstance) : null;

  const hasPermission = ((!direccionStr && permission.add) || (direccionStr && permission.change));

  return (
    <>
      <Col style={{ display: 'flex', flex: 1 }}>
        <Form.Item
          label="Dirección"
          name="direccionStr"
          rules={[{
            validator: async () => {
              if (required && !direccionStr) throw new Error('El campo es requerido');
            },
          }]}
          style={{ width: '100%' }}
        >
          <Input className="transparent-input" style={{ width: '100%' }} disabled />
        </Form.Item>
      </Col>
      {hasPermission && !onCancel && (
        <Col>
          <Button
            onClick={() => setVisible(true)}
            className="primary-on-hover"
            loading={loading}
            style={{ marginTop: 22 }}
            id="btn-direccion"
          >
            {!loading && <EnvironmentOutlined style={{ marginRight: 5 }} />}
            {`${direccionStr ? 'Editar' : 'Agregar'} Dirección`}
          </Button>
        </Col>
      )}
      <Modal
        width="90%"
        open={_visible || visible}
        closable={false}
        maskClosable={false}
        keyboard={!loading}
        footer={null}
        title={submitControlsWithSentWS ? (
          <FormSubmitControls
            label={`${formAddress?.getFieldValue('id') ? 'Editar' : 'Agregar'} Dirección`}
            onFinish={() => formAddress.onFinishHandler(null, false)}
            onCancel={onCancel || (() => setVisible(false))}
            loading={loading}
            onFinishText="Guardar sin enviar"
            customAction={() => formAddress.onFinishHandler(null, true)}
            customActionText="Guardar y enviar"
            allowCustomAction
            customActionIcon={<RightOutlined />}
          />
        ) : (
          <FormSubmitControls
            label={`${formAddress?.getFieldValue('id') ? 'Editar' : 'Agregar'} Dirección`}
            onFinish={() => formAddress.onFinishHandler(null, false).then(() => setVisible(false))}
            onCancel={onCancel || (() => setVisible(false))}
            loading={loading}
          />
        )}
        onCancel={onCancel}
        forceRender
        centered
      >
        <Spin spinning={loading}>
          <Direccion
            currentURI={baseURI}
            parentID={parentID}
            setLoading={setLoading}
            setFormAddress={setFormAddress}
            addressPropName={addressPropName}
            callback={callback}
            valuesCallback={(_, direccion) => formInstance
              ?.setFieldsValue({ direccionStr: address(direccion) })}
          />
        </Spin>
      </Modal>
    </>
  );
};

export default ModalDireccion;
